<div class="d-flex px-2" [class]="position==='end' ? 'justify-content-start':'justify-content-end'">
  <div *ngIf="!isMobile" class="d-flex align-items-center justify-content-end py-3 pe-2" [id]="id">
    <i [sch-icon]="toggleIcon" class="toggle-icon text-primary border border-primary"
      (click)="toggleMinimize.emit()"></i>
  </div>

  <div *ngIf="isMobile" class="d-flex align-items-center justify-content-end py-3 pe-2">
    <i [sch-icon]="toggleIcon" class="toggle-icon text-primary border border-primary" (click)="sideNavClose.emit()"></i>
  </div>
</div>